const features = [
  {
    icon: 'ri-database-2-line',
    title: '海量漫画资源',
    desc: '覆盖韩漫推荐、日漫大全、国漫排行榜等热门漫画类型，10万+作品持续扩充中，热门漫画一网打尽。',
  },
  {
    icon: 'ri-radar-line',
    title: '精准智能推荐',
    desc: '基于热度、评分和更新频率的多维度筛选，帮你从免费漫画大全中快速定位适合自己的好看漫画。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速更新同步',
    desc: '每日300+章节实时更新，韩漫、日漫、国漫最新连载第一时间呈现，追更不等待。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">平台特色</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">为什么数百万漫友选择UU漫画</p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {features.map((f, i) => (
            <div key={i} className="bg-background-100 rounded-lg border border-background-200/70 p-6 text-center">
              <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-accent-100 flex items-center justify-center">
                <i className={`${f.icon} text-accent-500 text-xl`} />
              </div>
              <h3 className="text-sm font-medium text-foreground-800 mb-2">{f.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}